import { FC } from 'react';

const TermsAndConditions: FC = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
        <p className="mb-4">
          By accessing and using this raffle platform, you agree to be bound by these Terms and Conditions.
          If you do not agree to these terms, please do not use the platform.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">2. Eligibility</h2>
        <p className="mb-4">
          Participants must be of legal age in their jurisdiction to enter raffles.
          Some raffles may have additional eligibility requirements.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">3. Entry Rules</h2>
        <ul className="list-disc pl-6 mb-4">
          <li className="mb-2">One entry per ticket purchase</li>
          <li className="mb-2">All entries are final and non-refundable</li>
          <li className="mb-2">Entries must be submitted before the raffle closing date</li>
          <li className="mb-2">Invalid or fraudulent entries will be disqualified</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">4. Winner Selection</h2>
        <p className="mb-4">
          Winners will be selected randomly from all valid entries.
          Winners will be notified via the contact information provided during entry.
          Prizes must be claimed within the specified timeframe.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">5. Privacy</h2>
        <p className="mb-4">
          Your personal information will be handled in accordance with our Privacy Policy.
          By entering a raffle, you agree to the collection and use of your information as described.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">6. Modifications</h2>
        <p className="mb-4">
          We reserve the right to modify these terms at any time.
          Continued use of the platform after changes constitutes acceptance of modified terms.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">7. Contact</h2>
        <p>
          For questions about these terms, please contact us at support@qraffle.com
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;